import '../../../includes/mlmi-elements/plugins/scroll-to';

const MAP_SELECTOR = '.locator-map__google-map';

const MAP_STYLE = [
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{color: '#e9e9e9'}, {lightness: 17}]
  },
  {
    featureType: 'landscape',
    elementType: 'geometry',
    stylers: [{color: '#f5f5f5'}, {lightness: 20}]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [{color: '#ffffff'}, {lightness: 17}]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{color: '#ffffff'}, {lightness: 29}, {weight: 0.2}]
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [{color: '#ffffff'}, {lightness: 18}]
  },
  {
    featureType: 'road.local',
    elementType: 'geometry',
    stylers: [{color: '#ffffff'}, {lightness: 16}]
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [{color: '#f5f5f5'}, {lightness: 21}]
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{color: '#dedede'}, {lightness: 21}]
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [{visibility: 'on'}, {color: '#ffffff'}, {lightness: 16}]
  },
  {
    elementType: 'labels.text.fill',
    stylers: [{saturation: 36}, {color: '#333333'}, {lightness: 40}]
  },
  {elementType: 'labels.icon', stylers: [{visibility: 'off'}]},
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [{color: '#f2f2f2'}, {lightness: 19}]
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.fill',
    stylers: [{color: '#fefefe'}, {lightness: 20}]
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [{color: '#fefefe'}, {lightness: 17}, {weight: 1.2}]
  }
];

const MAP_OPTIONS = {
  selectors: {
    form: '.locator-form',
    list: '.locations-list',
    where: 'input[name="where"]',
    radius: 'select[name="radius"]',
    limit: 'select[name="limit"]'
  },
  basicOptions: {
    zoom: 12,
    maxZoom: 18,
    minZoom: 5,
    lat: 45.554971,
    lng: -73.665509,
    mapStyle: MAP_STYLE,
    autoFadeIn: true,
    autoFitBounds: true,
    enableGeolocation: false,
    enablePositionMarker: true,
    putSearchParametersInURL: false
  },
  clusterOptions: {
    useClusters: true,
    styles: [
      {
        textColor: 'white',
        textSize: 14,
        textWeight: 600,
        url: script_l10n.MAP_CLUSTER,
        height: 36,
        width: 36,
        backgroundSize: '36px 36px',
        iconAnchor: [18, 18],
        anchor: [0, 0]
      }
    ],
    gridSize: 65,
    maxZoom: 16,
    zoomOnClick: 1,
    averageCenter: 1,
    minimumClusterSize: 3
  },
  bubbleOptions: {
    useBubbles: false
  },
  getMarkerIcon: function () {
    let markerIcon = {
      url: script_l10n.MAP_MARKER,
      height: 72,
      width: 72,
      anchorX: 18,
      anchorY: 18,
      scaledWidth: 36,
      scaledHeight: 36
    };
    return markerIcon;
  }
};

let self;

export default {
  locator: undefined,
  locations: [],

  init() {
    self = this;
    setTimeout(() => {
      this.attachEvents();
    }, 500);
  },

  attachEvents() {
    if ($(MAP_SELECTOR).length) {
      /* Initialize map when ready */
      if ('MLMI_Locator_Function' in window) {
        $.fn.MLMI_Locator = window.MLMI_Locator_Function;
      }
      if ($.fn.MLMI_Locator == undefined) {
        setTimeout(self.attachEvents, 50);
      } else {
        /* Initialize map */
        if ($.mlmi.mobile.isMobile) {
          MAP_OPTIONS.basicOptions.zoom = 5;
        }
        self.locator = $(MAP_SELECTOR).MLMI_Locator(MAP_OPTIONS);

        /* Get locations for filtering */
        if ('locations' in window) {
          self.locations = window.locations;
        }

        /* Events handling */
        self.locator.on('search_started', function () {
          $('.locations-list').addClass('locations-list--loading');
        });

        /* Check for bounds */
        let geolocation = undefined,
          bounds_fit = false;
        self.locator.on('geolocation_denied', function () {
          geolocation = false;
          if (bounds_fit === true) {
            self.locator.addClass('locator-map__google-map--visible');
          }
        });
        self.locator.on('geolocation_accepted', function () {
          geolocation = true;
          $('.locations-list').addClass('locations-list--loading');
          $('input[name="where"]').prop('required', false);
        });
        self.locator.on('bounds_fit', function () {
          bounds_fit = true;
          if (geolocation === false || geolocation === true) {
            self.locator.addClass('locator-map__google-map--visible');
          }
        });

        self.locator.on('marker_clicked', function (event, locator, marker) {
          $('.location-item').removeClass('bg-cream');
          let locationItem = $('.location-item[data-id=' + marker.location.id + ']');
          locationItem.addClass('bg-cream');
          if ($.mlmi.mobile.isMobile) {
            $('html, body').scrollTo(locationItem.offset().top - $('.header').outerHeight() - 24);
          } else {
            $('.locations-list').scrollTo(
              locationItem.offset().top -
              $('.locations-list').offset().top +
              $('.locations-list').scrollTop() -
              ($('.locations-list').outerHeight(false) - locationItem.outerHeight(false)) / 2
            );
          }
        });

        $('.locator-form__submit').on('click', function () {
          if ($.mlmi.mobile.isMobile) {
            if (!$('input[name="where"]').prop('required') || $('input[name="where"]').val()) {
              $('html, body').scrollTo($('.locator-map').offset().top - $('.header').outerHeight() - 24);
            }
          }
        });
      }
    }
  }
};
